export default __webpack_public_path__ + "static/media/PWD.376bb749.png";